////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const articleManager = {
	getAvailableLists: () => ({
		type: ActionsTypes.GET_ARTICLE_AVAILABLE_LISTS,
	}),
	getAvailableListsSuccess: (data) => ({
		type: ActionsTypes.GET_ARTICLE_AVAILABLE_LISTS_SUCCESS,
		payload: {
			data,
		},
	}),
	getAvailableListsFailure: (error) => ({
		type: ActionsTypes.GET_ARTICLE_AVAILABLE_LISTS_FAILURE,
		payload: {
			error,
		},
	}),
	createArticle: (data) => ({
		type: ActionsTypes.CREATE_ARTICLE,
		payload: {
			data,
		},
	}),
	createArticleSuccess: (data) => ({
		type: ActionsTypes.CREATE_ARTICLE_SUCCESS,
		payload: {
			data,
		},
	}),
	createArticleFailure: (error) => ({
		type: ActionsTypes.CREATE_ARTICLE_FAILURE,
		payload: {
			error,
		},
	}),
	getArticleItem: (id) => ({
		type: ActionsTypes.GET_ARTICLE_ITEM,
		payload: {
			id,
		},
	}),
	getArticleItemSuccess: (data) => ({
		type: ActionsTypes.GET_ARTICLE_ITEM_SUCCESS,
		payload: {
			data,
		},
	}),
	getArticleItemFailure: (error) => ({
		type: ActionsTypes.GET_ARTICLE_ITEM_FAILURE,
		payload: {
			error,
		},
	}),
	updateArticle: (data, id) => ({
		type: ActionsTypes.UPDATE_ARTICLE,
		payload: {
			data,
			id,
		},
	}),
	updateArticleSuccess: (data) => ({
		type: ActionsTypes.UPDATE_ARTICLE_SUCCESS,
		payload: {
			data,
		},
	}),
	updateArticleFailure: (error) => ({
		type: ActionsTypes.UPDATE_ARTICLE_FAILURE,
		payload: {
			error,
		},
	}),
	deleteArticle: (id) => ({
		type: ActionsTypes.DELETE_ARTICLE,
		payload: {
			id,
		},
	}),
	deleteArticleSuccess: (data) => ({
		type: ActionsTypes.DELETE_ARTICLE_SUCCESS,
		payload: {
			data,
		},
	}),
	deleteArticleFailure: (error) => ({
		type: ActionsTypes.DELETE_ARTICLE_FAILURE,
		payload: {
			error,
		},
	}),
	resetDataArticle: () => ({
		type: ActionsTypes.RESET_DATA_ARTICLE,
	}),
}

export default articleManager
